/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABv0lEQVR4nN1UXytEURDfVy1RiBKvnnjw4AtoEXfOzKYxs1r5ArxsUmw8ePMh+ACb2ldFFHn2SRAeFLU098/6s3vv3rVKmZq659w58zu/38ycTOZfGaKMOpJjIH10pG/teHBGqs7xeGxyQL1tN7FrcLmzXA0AdvPOk2vgqJUGgJ/I4uJZPDRh8FvJ1fdEACDdzuWKWUDZSVHcprGJAMzc7e8519MKIC42mQHKjh10JOWWDGJi/7YG7qMbyp5XGACSm0bt5SYczL0mZ2upAAB1y/4FIHpkQ2TDCCiHRKv9wT8eQ1yZYOYucwCd9Ehm00r06mFhKfMblqgpasVDmUFc61tgHo46xwzyOg8kJyG7J0d6hrg8B6TXDuWq7SID6m0kjyPdT13s9ACya/GIhYVw/eJISlanxUUescEL9n4I4OWXp3xpSE/DTivV5TJZ4hikfeyYudePD592u3n9kihXX1tZLz8xkGoagFyumA3j72wd1aN1Fzkejw4lOVFhOmR88V2iluZPJmrF3vMYgJoVN7iQuqjIHsomgA7NMw/63yT3QLKeGjiWNclBQjtvdAxgBiQIpOd+a6I8W3fZ8EUB77i8r5mQhMu7AAAAAElFTkSuQmCC)
 */
export const StickerRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M22 11.82c0 .2-.14.4-.33.49h-.02a.58.58 0 0 1-.44.05 7 7 0 0 0-4.55.04 1 1 0 0 0-1.75-.96 3.5 3.5 0 0 1-5.82 0 1 1 0 0 0-1.66 1.12 5.5 5.5 0 0 0 5.95 2.27 6.97 6.97 0 0 0-1 6.44c.11.35-.13.73-.5.73H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v5.82ZM6.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
